import { Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import ErrorBoundary from '../ErrorBoundary';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import ProvidersBySettingType from './ProvidersBySettingType';
import ProvidersChange from './ProvidersChange';
import ToggleBy from './ToggleBy';
import TotalNumberOfProviders from './TotalNumberOfProviders';

function StoryQ2() {
  const { lightColor, darkColor } = useContext(StoryContext);
  const [displayBy, setDisplayBy] = useState('Providers');

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
    dataGrid: {
      marginTop: theme.spacing(2),
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <FiltersContext.Provider value={{
        displayBy,
        setDisplayBy,
      }}
      >
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >

          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              How has COVID-19 affected the overall supply of child care?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ToggleBy />
          </Grid>
          <Grid item xs={10} sm={7}>
            <MessageBox>
              <Typography variant="body1" align="left">
                <ErrorBoundary>
                  <ProvidersChange />
                </ErrorBoundary>
              </Typography>
            </MessageBox>
          </Grid>
        </Grid>
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.dataGrid}
        >
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <TotalNumberOfProviders height={320} />
            </ErrorBoundary>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <ProvidersBySettingType height={320} />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </FiltersContext.Provider>
    </SubquestionBox>
  );
}

export default StoryQ2;
